import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PaymentMethodEditBase } from './paymentMethodEditBase';

const PaymentMethodEdit = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <PaymentMethodEditBase
      goBack={() => navigate(-1)}
      card={state}
    />
  );
}

export default PaymentMethodEdit;
